import { useNavigate } from "react-router-dom";

export default function Page404() {
    const navigate = useNavigate();

    const handleHomeClick = () => {
        navigate("/dashboard");
    }

    return (
        <div className="page-404">
            <h1>Error 404</h1>
            <h2>Page not found.</h2>
            <div className="home" onClick={handleHomeClick}>Home</div>
        </div>
    );
};